import { ReactComponent as ArrowIcon } from '@paradigm/icons/src/mailru/navigation/arrow_list_next.svg';
import classNames from 'clsx';
import { ReactComponent as AuthIcon } from 'img/icons/mobile/auth.svg';
import React, { memo, ReactElement, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authPopup } from 'reactApp/modules/ph/ph.thunkActions';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { Avatar } from 'reactApp/ui/Avatar/Avatar';
import { OptionsBlock } from 'reactApp/ui/Mobile/OptionsModal/OptionsBlock/OptionsBlock';
import { renderUserChangeModal } from 'reactApp/ui/Mobile/UserChangeModal/UserChangeModal.helpers';
import { noopVoid } from 'reactApp/utils/helpers';

import styles from './UserBlock.css';

export const UserBlock = memo(
    ({
        onClose = noopVoid,
        isLeftMenu = false,
        reloginAction = false,
    }: {
        onClose?: () => void;
        isLeftMenu?: boolean;
        reloginAction?: boolean;
    }): ReactElement | null => {
        const email = useSelector(UserSelectors.getEmail);
        const login = useSelector(UserSelectors.getLogin);
        const dispatch = useDispatch();

        const onClick = useCallback(() => {
            renderUserChangeModal({ reloginAction });
        }, [reloginAction]);

        const onAuth = useCallback(() => {
            dispatch(
                authPopup({
                    closable: true,
                    loginRequest: true,
                    successPage: window.location.href,
                })
            );
        }, [dispatch]);

        const authItems = useMemo(
            () => [
                {
                    id: 'auth',
                    text: 'Войти в аккаунт',
                    icon: <AuthIcon />,
                    onClick: onAuth,
                },
            ],
            [onAuth]
        );

        if (!email) {
            return <OptionsBlock id="auth" onClose={onClose} items={authItems} />;
        }

        return (
            <div
                className={classNames(styles.root, {
                    [styles.root_leftMenu]: isLeftMenu,
                })}
                onClick={onClick}
            >
                <div className={styles.avatar}>
                    <Avatar size={isLeftMenu ? 46 : 32} email={email} />
                </div>
                <div className={styles.info}>
                    <div className={styles.login}>{login}</div>
                    <div className={styles.email}>{email}</div>
                </div>
                {isLeftMenu && (
                    <div className={styles.arrow}>
                        <ArrowIcon height={20} width={20} fill="currentColor" />
                    </div>
                )}
            </div>
        );
    }
);

UserBlock.displayName = 'UserBlock';
